import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-control-geocoder";

const LeafletGeocoder = () => {
	const map = useMap();
	const lang = localStorage.getItem("lang") || "en";

	const markerRef = useRef(null);

	useEffect(() => {
		if (!map) return;

		const geocoder = L.Control.geocoder({
			defaultMarkGeocode: false, // disable default marker + popup
			position: lang === "en" ? "bottomright" : "bottomleft",
		})
			.on("markgeocode", function (e) {
				const { center } = e.geocode;

				// Remove old marker if exists
				if (markerRef.current) {
					map.removeLayer(markerRef.current);
				}

				// Add new marker WITHOUT popup
				const marker = L.marker(center).addTo(map);
				markerRef.current = marker;

				// Zoom to the location
				map.setView(center, 15); // optional: change zoom level as needed
			})
			.addTo(map);

		return () => {
			map.removeControl(geocoder);
			if (markerRef.current) {
				map.removeLayer(markerRef.current);
			}
		};
	}, [map]);

	return null;
};

export default LeafletGeocoder;
